import React, {Component} from 'react';
import {Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Edit2, Trash} from "react-feather";
import {Col, OverlayTrigger, Row, Spinner, Tooltip} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import AddVoucherModalForm from "./modals/AddVoucherModal";
import Moment from "moment";
import DeleteProductSponsoringModal from "./modals/DeleteProductSponsoringModal";
import AddManualReporting from "./modals/AddManualReporting";
import AddAdidasVouchers from "./modals/AddAdidasVouchers";
import AddVoucherInfoModalForm from "./modals/AddVoucherInfoModal";
import UpdateProductSponsoringForm from "./modals/UpdateProductSponsoringModal";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import {CiWarning} from "react-icons/ci";
import InfiniteScroll from "react-infinite-scroll-component";
import { apiFetch, API, getMarket } from "../services/api";

function getProductsSponsoring() {
    return apiFetch(API.products + '/products-sponsoring', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getMerchands() {
    return apiFetch(API.products + '/merchants', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function updateState(productSponsoring, checked) {
    productSponsoring.enable = checked
    productSponsoring.language = getMarket()
    return apiFetch(API.products + '/product-sponsoring', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(productSponsoring)
    }).then()
        .catch( err =>
            console.log(err)
        )
}

export class ProductsSponsoringList extends Component{
    state = {
        productSponsorings: [],
        countOfEmptyDescription: 0,
        countOfEmptyEvents: 0,
        isOpen: false,
        isVouchersOpen: false,
        errors: null,
        lastEvaluatedKey: null,
        selectedProductSponsoring : {
            declinations: [],
            name: "",
            description: "",
            metaTitle:"",
            metaDescription:"",
        }
    }

    async componentDidMount() {
        await getProductsSponsoring().then(data => {
            this.setState({ productSponsorings: data ? data : [], errors : "", loading: false })
        }).catch(err =>
                console.log(err),
            this.setState({errors: "error while getting productSponsorings"})
        );
        await getMerchands().then(data => {
            this.setState({ availableMerchands: data, errors : "" })
        }).catch(err =>
            this.setState({errors: "error while getting merchands"})
        );
    };

    closeModal = () => this.setState({ isOpen: false, selectedProductSponsoring: {
            events: [],
            name: "",
            description: "",
            metaTitle:"",
            metaDescription:"",
        } });

    render(){

        return(
            <div className="products-list">
                <Row>
                    <Col sm={4} className="products-buttons">
                        <span>Nombre de sponsoring de produit : {this.state.productSponsorings.length}</span>
                    </Col>

                    <Col sm={8} className="products-buttons" style={{textAlign:"right"}}>
                        <Button className="add-product-button " variant="secondary" type="submit"onClick={(e) => this.setState({isOpen : true})}>Ajouter un sponsoring de produit</Button>
                    </Col>
                </Row>
                { (!this.state.productSponsorings) ? <p> Aucun sponsoring de produit disponible.</p>
                    :
                    <Table responsive>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Nom</th>
                                <th>Nombre coloris</th>
                                <th>Date de lancement</th>
                                <th>Date de fin</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                                {!this.state.loading ? this.state.productSponsorings.length > 0 && this.state.productSponsorings.map(productSponsoring => (
                            <tr key={productSponsoring.id}>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Afficher le produit sur le site</Tooltip>}
                                >
                                    <td><BootstrapSwitchButton
                                        checked={productSponsoring.enable}
                                        onlabel='oui'
                                        onstyle='success'
                                        offlabel='non'
                                        offstyle='danger'
                                        size='xs'
                                        onChange={(checked: boolean) => {
                                            updateState(productSponsoring, checked)
                                        }}
                                    /></td>
                                </OverlayTrigger>
                                <td>{productSponsoring.name}</td>
                                <td>{productSponsoring.declinations ? productSponsoring.declinations.length : 0}</td>
                                <td>{Moment(productSponsoring.beginDate).format('DD-MM-YYYY').toString()}</td>   
                                <td>{Moment(productSponsoring.endDate).format('DD-MM-YYYY').toString()}</td>                                                             
                                <td className="table-action">
                                    <Edit2 className="align-middle mr-1" size={18} onClick={(e) => this.setState({isOpen : true, selectedProductSponsoring : productSponsoring})}/>
                                </td>
                                <td className="table-action">
                                    <Trash className="align-middle" size={18}onClick={(e) => this.setState({isDelete: true, selectedProductSponsoring: productSponsoring})} />
                                </td>
                            </tr>
                        )) : null}                                          
                        </tbody>
                    </Table>
                    }
                { this.state.isOpen ?
                    <UpdateProductSponsoringForm
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        handleSubmit={this.handleSubmit}
                        availableMerchands={this.state.availableMerchands}
                        selectedProductSponsoring={this.state.selectedProductSponsoring}
                    />
                    :
                    null
                }
                {this.state.isDelete ?
                    <DeleteProductSponsoringModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        handleSubmit={this.handleSubmit}
                        selectedItem={this.state.selectedProductSponsoring}
                        selectedCategory="productSponsoring"
                    />
                    :
                    null
                }
            </div>
        );

    }

}